import { IStoryMargins } from '../types';

export const CLICK = 'click';
export const SCROLL = 'scroll';
export const BACKGROUND = 'background';
export const FONT = 'font';

export const STATE_PUBLISHED = 'published';
export const STATE_INTERNAL_PUBLISHED = 'internalPublished';
export const STATE_DRAFT = 'draft';
export const STATE_UNPUBLISHED = 'unpublished';
export const STATE_TEMPLATE = 'template';
export const STATE_ARCHIVED = 'archived';
export const STATE_ANALYTICS = 'analytics';
export const STATE_ALL = 'all';
export const STATE_ALL_REPORT_EMBEDS = 'allReportEmbeds';

export const TAB_PUBLISHED = '';
export const TAB_DRAFTS = 'drafts';
export const TAB_TEMPLATES = 'templates';
export const TAB_ANALYTICS = 'analytics';
export const TAB_STORIES = 'stories';
export const TAB_REPORTS = 'embedded-reports';
export const TAB_CUSTOM_REPORTS = 'custom-reports';
export const TAB_PUBLICATIONS = 'publications';

export const PATH_STORY = 'story';
export const PATH_TEMPLATE = 'template';
export const PATH_CREATE_FROM_TEMPLATE = 'create-from-template';
export const PATH_TEMPLATES = 'templates';
export const PATH_EDIT = 'edit';
export const PATH_PREVIEW = 'preview';

export const VISIBILITY_ORG = 'organization';
export const VISIBILITY_PRIVATE = 'private';
export const VISIBILITY_NETWORK = 'network';

export const VISIBLITY_STORY_STATE_PRIVATE = 'Draft';
export const VISIBLITY_STORY_STATE_INTERNAL_PUBLISHED = 'Organizational';
export const VISIBLITY_STORY_STATE_PUBLISHED = 'Public';
export const VISIBLITY_STORY_STATE_ALL = 'All';

export const SORT_NAME_A_Z = 'title';
export const SORT_NAME_Z_A = '-title';
export const SORT_CREATED_NEW_TO_OLD = '-createdAt';
export const SORT_CREATED_OLD_TO_NEW = 'createdAt';
export const SORT_CUSTOM = 'custom';
export const SORT_UPDATED_NEW_TO_OLD = '-updatedAt';
export const SORT_UPDATED_OLD_TO_NEW = 'updatedAt';
export const SHOW_ALL = 'SHOW_ALL';
export const SHOW_USER = 'SHOW_USER';

export const ONLY_GRAPH = 'ONLY_GRAPH';
export const ONLY_TABLE = 'ONLY_TABLE';

export const VIEW_GRID = 'VIEW_GRID';
export const VIEW_LIST = 'VIEW_LIST';

export const SORT = 'sort';
export const STORY_VISIBILITY = 'storyVisibility';
export const PUBLICATION_VISIBILITY = 'publicationVisibility';
export const STORY_ACCESS = 'storyAccess';
export const VIEW = 'view';
export const SHOW = 'show';

export const REPORT_EMBED_CREATED_BY = 'reportEmbedCreatedBy';
export const REPORT_EMBED_SORT = 'reportEmbedSort';
export const REPORT_EMBED_TYPE = 'reportEmbedType';

export const CONFIRM_DELETE = 'DELETE';

export const STORY_CONTENT_CARD = 'STORY_CONTENT_CARD';

export const STORY_CARD_IMAGE_HEIGHT = '220px';
export const PUBLICATION_CARD_IMAGE_HEIGHT = '220px';

export const AUTOSAVE_TIMEOUT = 3000; // milliseconds

export const XHR_READY = 4;
export const XHR_SUCCESS_CODE = 200;

export const DEFAULT_PER_PAGE = 20;
export const MAX_TOTAL_BODY_CONTENTS_FOR_EDIT = 30;
export const MAX_TOTAL_BODY_CONTENTS_FOR_API = 100;

export const MAX_TITLE_LENGTH = 60;
export const MAX_DESCRIPTION_LENGTH = 150;
export const MIN_TITLE_LENGTH = 3;

export const FOLDER_SELECT_MENU_HEIGHT = 280;

export const EDIT_STORY_RESOURCE = 'feature-edit-story-resources';

export const FLAG_STORIES_CONTENT_BREAKS_AND_PADDING = 'product-stories-feature-content-breaks-and-padding';
export const FLAG_STORIES_PAGE_BREAK_EXPORTS = 'product-stories-feature-page-break-exports';
export const FLAG_ADD_PROPOSALS_TO_STORIES = 'product-budget-feature-add-proposals-to-stories';
export const FLAG_STORIES_BULK_UPDATE_STATUS = 'product-stories-bulk-update-story-status';
export const FLAG_FEATURE_REPORTING_EMBED_V3 = 'product-feature-reporting-embed-v3';
export const FLAG_STORIES_REMOVE_JS_EMBEDS = 'product-stories-remove-js-embeds';
export const FLAG_STORIES_AI_STORY_CONTENT_GENERATION = 'product-budget-feature-story-content-ai-generation';
export const FLAG_STORIES_SUMMARIZER_GA = 'product-budget-feature-stories-summarizer-ga';
export const FLAG_STORIES_OG_ASSIST_GENERATE_SUMMARY = 'product-stories-og-assist-generate-summary';
export const FLAG_PRODUCT_STORIES_PUBLICATIONS_GOOGLE_TRANSLATOR = 'product-stories-publications-google-translator';
export const FLAG_PRODUCT_STORIES_ACCESS_CONTROL = 'product-budget-stories-access-control';
export const FLAG_PRODUCT_REPORTING_FEATURE_ACCOUNT_SUMMARY_CHARTS_IN_EMBEDS =
  'product-reporting-feature-account-summary-charts-in-embeds';
export const FLAG_PRODUCT_REPORTING_CHART_AND_DETAILS_V3_ENABLED = 'product-reporting-chart-and-details-v3-enabled';
export const FLAG_BNP_NEW_REPORT_TILE_MODAL = 'bnp-new-report-tile-modal';
export const FLAG_PRODUCT_REPORTING_FEATURE_CHARTS_CUSTOMIZATION_TITLE_AND_DESCRIPTION =
  'product-reporting-feature-charts-customization-title-and-description';

export const ANALYTICS_DATE_RANGE_OPTIONS = [
  { id: 'month', name: 'Show past month' },
  { id: 'day', name: 'Show last 24 hours' },
  { id: 'week', name: 'Show past week' },
  { id: 'year', name: 'Show past year' }
];

export const DEFAULT_STORY_MARGINS: IStoryMargins = {
  // The values for top/bottom margin are chosen to align with the preset
  // margins in applications/content-export-service/routes/exportPdf.ts
  marginTop: 0.25,
  marginBottom: 0.25,
  marginLeft: 1,
  marginRight: 1
};

export const ENTITY_USER = 'entity_user';

export const UNIQUENESS_VIOLATION = 'Uniqueness violation.';

export const SUMMARY_TABLE_EMBED_REQUEST = 'SUMMARY_TABLE_EMBED_REQUEST';

export const DETAIL_TABLE_EMBED_REQUEST = 'DETAIL_TABLE_EMBED_REQUEST';

export const REPORT_TABLE = 'REPORT_TABLE';

export const REPORT_GRAPH = 'REPORT_GRAPH';

export const TABLE = 'Table';

export const GRAPH = 'Graph';

export const CHART_TYPE = {
  Gauge: 'gauge',
  Line: 'line',
  MultiLine: 'multi_line',
  PercentBulletBar: 'percent_bullet_bar',
  Bar: 'bar',
  BulletBar: 'bullet_bar',
  LineGrid: 'line_grid',
  BarGrid: 'bar_grid',
  SplitBar: 'split_bar',
  GroupedBarChart: 'grouped_bar_chart',
  BarChart: 'bar_chart',
  StackedBarChart: 'stacked_bar_chart',
  LineChart: 'line_chart',
  PieChart: 'pie_chart',
  Default: 'default',
  TransparencyHorizontalStackedBar: 'transparency_hz_stacked_bar',
  TransparencyStackedBar: 'transparency_stacked_bar',
  TransparencyPie: 'transparency_pie',
  TransparencyTable: 'transparency_table'
};

export const DATE_FORMAT_WITH_TIMEZONE = 'YYYY-MM-DDTHH:mm:ss.sssZ';

export const STORIES_ADMIN_PRIVILEGE = 'STORIES_ADMIN_PRIVILEGE';
export const STORIES_SUPER_ADMIN_PRIVILEGE = 'STORIES_SUPER_ADMIN_PRIVILEGE';
export const STORIES_CREATE_PRIVILEGE = 'STORIES_CREATE_PRIVILEGE';
export const STORIES_SHARED_PRIVILEGE = 'STORIES_SHARED_PRIVILEGE';
export const STORIES_EDITOR_PRIVILEGE = 'STORIES_EDITOR_PRIVILEGE';
export const STORIES_PUBLISHER_PRIVILEGE = 'STORIES_PUBLISHER_PRIVILEGE';
export const STORIES_VIEWER_PRIVILEGE = 'STORIES_VIEWER_PRIVILEGE';
export const STORIES_PDF_GENERATION_PRIVILEGE = 'STORIES_PDF_GENERATION_PRIVILEGE';
export const VIEW_SECTIONS_PRIVILEGE = 'VIEW_SECTIONS_PRIVILEGE';
export const PUBLICATIONS_MANAGER_PRIVILEGE = 'PUBLICATIONS_MANAGER_PRIVILEGE';
export const CONTAINERS = {
  FOLLOW_CONTAINER: 'follow-container',
  PROGRESS_TRACKER_CONTAINER: 'progress-tracker-container'
};
export const COMMENTS_TAB_ID = 'comments';
export const COMMENTS_TAB_TITLE = 'Comments';
export const SIDE_PANEL_TABS_SECTION_TITLE = 'Story';
export const TOPIC_TYPE_STORY = 'STORY';
export const TERMS_AND_CONDITIONS_URL = 'https://stories.opengov.com/stories-community/publicEngagementTerms.html';
